import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { GetAlumniProfile, IMG_BASE_URL3 } from '../../AllAPI/AdminAPI'

const AlumniProfile = () => {
  const [profile, setProfile] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  const alumniData = sessionStorage.getItem('alumniData')
  const parsedData = JSON.parse(alumniData)
  const signupId = parsedData.signup_id

  useEffect(() => {
    const getProfile = async () => {
      try {
        const response = await axios.get(`${GetAlumniProfile}/${signupId}`)
        setProfile(response.data)
      } catch (err) {
        setError('Failed to load profile')
      } finally {
        setLoading(false)
      }
    }

    getProfile()
  }, [])

  if (loading) return <div style={styles.center}>Loading...</div>

  if (error) return <div style={styles.centerError}>{error}</div>

  if (!profile) return <div style={styles.center}>No profile found</div>

  const fullName = `${profile?.f_name || ''} ${profile?.m_name || ''} ${
    profile?.l_name || ''
  }`

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        {/* Header */}
        <div style={styles.header}>
          <img
            src={`${IMG_BASE_URL3}/${profile.profile_img}`}
            alt="Profile"
            style={styles.avatar}
            onError={(e) => (e.target.src = 'https://via.placeholder.com/150')}
          />

          <h2 style={styles.name}>{fullName}</h2>
          <p style={styles.subText}>{profile.jobCategoryData.category_name}</p>
        </div>

        {/* GRID START */}
        <div style={styles.grid}>
          <Info label="DOB" value={profile?.date_of_birth} />
          <Info label="Blood Group" value={profile?.blood_group} />
          <Info label="Email" value={profile?.email} />
          <Info label="Mobile" value={profile?.mobile} />

          <Info label="Qualification" value={profile?.qualification} />
          <Info label="Business" value={profile?.business_service_name} />
          <Info
            label="Boarding Year"
            value={`${profile?.from_year_of_boarding || '-'} - ${
              profile?.to_year_of_boarding || '-'
            }`}
          />

          <Info label="Pincode" value={profile?.pincode} />
          <Info label="State" value={profile?.stateData.stateenname} />
          <Info label="District" value={profile?.districtData.districtenname} />
          <Info label="Taluka" value={profile?.talukaData.talukaenname} />

          
        </div>

      </div>
    </div>
  )
}

/* ---------- Reusable Components ---------- */

const Section = ({ title, children }) => (
  <div style={styles.section}>
    <h3 style={styles.sectionTitle}>{title}</h3>
    <div>{children}</div>
  </div>
)

const Info = ({ label, value }) => (
  <div style={styles.infoBox}>
    <div style={styles.infoLabel}>{label}</div>
    <div style={styles.infoValue}>{value || '-'}</div>
  </div>
)

/* ---------- Inline Styles ---------- */

const styles = {
  page: {
    background: '#f4f6f9',
    display: 'flex',
    justifyContent: 'center',
    padding: '40px 15px',
    fontFamily: 'Arial, sans-serif',
    marginBottom:'30px'
  },

  card: {
    width: '100%',
    maxWidth: '900px',
    background: '#fff',
    borderRadius: '16px',
    boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
    padding: '25px',
  },

  header: {
    textAlign: 'center',
    paddingBottom: '20px',
    borderBottom: '1px solid #eee',
    marginBottom: '20px',
  },

  avatar: {
    width: '110px',
    height: '110px',
    borderRadius: '50%',
    objectFit: 'cover',
    border: '4px solid #4f46e5',
  },

  name: {
    margin: '10px 0 5px',
    fontSize: '22px',
  },

  subText: {
    color: '#666',
    fontSize: '14px',
  },

  /* GRID LAYOUT */
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: '12px',
    marginTop: '20px',
  },
  

  infoBox: {
    background: '#f9fafb',
    padding: '10px 12px',
    borderRadius: '10px',
    border: '1px solid #eee',
  },

  infoLabel: {
    fontSize: '12px',
    color: '#666',
    marginBottom: '3px',
  },

  infoValue: {
    fontSize: '14px',
    fontWeight: '600',
    color: '#333',
  },

  fullWidthBox: {
    marginTop: '15px',
    padding: '12px',
    background: '#fafafa',
    borderRadius: '10px',
    border: '1px solid #eee',
  },

  sectionTitle: {
    fontSize: '15px',
    color: '#4f46e5',
    marginBottom: '6px',
  },

  text: {
    fontSize: '14px',
    color: '#444',
    lineHeight: '1.5',
  },
}

export default AlumniProfile
